import React from "react";
import { Link } from "react-router-dom";
import { FaPhone, FaEnvelope, FaHome } from "react-icons/fa";

function Footer() {
  return (
    <footer>
      <div className="footer-content">
        <div className="footer-section">
          <h3>Lackfertighaus</h3>
          <p>
            Professionelle Ausbauarbeiten und erstklassige Handwerkskunst seit
            2010. Wir setzen Maßstäbe in Qualität und Präzision.
          </p>
        </div>

        <div className="footer-section">
          <h3>Kontakt</h3>
          <p>
            <FaHome /> Karlplatz 5c, 74737 Elsdorf, Deutschland
          </p>
          <p>
            <FaPhone /> +493455716202
          </p>
          <p>Email: lackfertighaus@hotmail.com</p>
          <p>
            <a href="https://wa.me/493455716202">WhatsApp</a>
          </p>
          <p>
            <a href="https://viber.me/493455716202">Viber</a>
          </p>
          <p>
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noopener noreferrer">
              Facebook
            </a>
          </p>
          <p>
            <a
              href="https://www.instagram.com/accounts/login/"
              target="_blank"
              rel="noopener noreferrer">
              Instagram
            </a>
          </p>
          <p>Registernummer: 75700895</p>
        </div>

        <div className="footer-section">
          <h3>Navigation</h3>
          <Link to="/">Startseite</Link>
          <Link to="/about">Über uns</Link>
          <Link to="/contact">Kontakt</Link>
          <Link to="/cart">Warenkorb</Link>
        </div>

        <div className="footer-section">
          <h3>Rechtliches</h3>
          <Link to="/privacy-policy">Datenschutzerklärung</Link>
          <Link to="/terms-conditions">Allgemeine Geschäftsbedingungen</Link>
          <Link to="/refund-policy">Rückgaberecht</Link>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2026 Lackfertighaus. Alle Rechte vorbehalten.</p>
        
      </div>
    </footer>
  );
}

export default Footer;
